module.exports = __webpack_public_path__ + "static/img/3.596b04d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/3.png
// module id = NDlC
// module chunks = 0